/*
 * sp-search-synonyms.js — 2026-07-26
 *
 * Corrects a SMALL set of search terms where the customer's word is genuinely
 * different from ours, before the query reaches Shopify search.
 *
 * IMPORTANT CONTEXT FOR WHOEVER EDITS THIS NEXT:
 * Shopify's native search already has good built-in typo tolerance. It was tested
 * term-by-term against the live storefront on 2026-07-26, and it already resolves
 * "saphire", "earings", "studs", "portugese", "coloured", "hexagonal", "old miners",
 * "dutch marquee" and "marquis" correctly on its own. Those were deliberately NOT
 * added here — mapping them would be dead code, and one of them ("old miners")
 * actually returned marginally fewer results when rewritten.
 *
 * Only mappings VERIFIED to change results for the better are kept:
 *   teardrop / tear drop  -> pear     (before: "Drop Earrings" + unrelated settings;
 *                                      after: actual Pear jewelry. ~59 searches/yr)
 *   ascher / asher        -> asscher  (before: NO Asscher products at all;
 *                                      after: Asscher studs + hoops. ~24 searches/yr)
 *   vela                  -> vella    (before: nothing; after: The Vella Setting. ~8/yr)
 *
 * Terms we simply DON'T stock (rose cut, alexandrite, natural, novak, moissanite,
 * black/pink/blue diamond...) are intentionally NOT mapped — redirecting those would
 * hide a real inventory gap behind a false positive.
 *
 * Three interception points, all fail-open (any error = original query is used):
 *   1. the predictive-search dropdown fetch (/search/suggest)
 *   2. the search form submit
 *   3. direct arrivals on /search?q=  (guarded against redirect loops)
 */
(function () {
  'use strict';

  /* single-token corrections — applied to any word in the query */
  var WORD = {
    ascher: 'asscher',
    asher: 'asscher',
    ashcer: 'asscher',
    vela: 'vella',
    teardrop: 'pear'
  };

  /* whole-query replacements (only when the entire query matches) */
  var PHRASE = {
    'tear drop': 'pear',
    tear: 'pear'
  };

  var GUARD = 'sqfix';

  function normalize(q) {
    if (typeof q !== 'string' || !q) return q;
    var key = q.toLowerCase().replace(/\s+/g, ' ').trim();
    if (!key) return q;
    if (Object.prototype.hasOwnProperty.call(PHRASE, key)) return PHRASE[key];

    var toks = key.split(' ');
    var changed = false;
    for (var i = 0; i < toks.length; i++) {
      var bare = toks[i].replace(/[^a-z0-9]/g, '');
      if (bare && Object.prototype.hasOwnProperty.call(WORD, bare)) {
        toks[i] = WORD[bare];
        changed = true;
      }
    }
    return changed ? toks.join(' ') : q;
  }

  /* rewrite the q= param of a URL, preserving every other param */
  function rewriteUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      var q = u.searchParams.get('q');
      if (q == null) return url;
      var fixed = normalize(q);
      if (fixed === q) return url;
      u.searchParams.set('q', fixed);
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  /* ---- 1. predictive-search dropdown ---------------------------------- */
  try {
    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        try {
          if (typeof input === 'string' && input.indexOf('/search/suggest') !== -1) {
            input = rewriteUrl(input);
          }
        } catch (e) { /* fail open */ }
        return origFetch.call(this, input, init);
      };
    }
  } catch (e) { /* fail open */ }

  /* ---- 2. search form submit ------------------------------------------ */
  try {
    document.addEventListener('submit', function (ev) {
      try {
        var form = ev.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/search') === -1) return;
        var input = form.querySelector('input[name="q"]');
        if (!input) return;
        var fixed = normalize(input.value);
        if (fixed !== input.value) input.value = fixed;
      } catch (e) { /* fail open */ }
    }, true);
  } catch (e) { /* fail open */ }

  /* ---- 3. direct arrival on the results page --------------------------- */
  try {
    if (window.location.pathname.indexOf('/search') === 0) {
      var params = new URLSearchParams(window.location.search);
      if (!params.has(GUARD)) {
        var q = params.get('q');
        var fixed = normalize(q);
        if (q && fixed !== q) {
          params.set('q', fixed);
          params.set(GUARD, '1');
          window.location.replace(window.location.pathname + '?' + params.toString());
        }
      }
    }
  } catch (e) { /* fail open */ }
})();
